module.exports = __webpack_public_path__ + "img/icon_share.7d2bf4a4.png";